import React from "react";

export const bolt = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.748 3.57199C12.807 3.06898 12.216 2.79498 11.913 3.18398L4.11102 13.197C3.85302 13.527 4.07302 14.029 4.47502 14.029H11.463C11.748 14.029 11.969 14.296 11.933 14.599L11.253 20.429C11.193 20.931 11.783 21.205 12.087 20.816L19.889 10.803C20.147 10.473 19.927 9.97098 19.525 9.97098H12.537C12.252 9.97098 12.031 9.70398 12.067 9.40098L12.748 3.57199Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
